import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { creations } from '../../data/mock';

const CreationsPreview = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 lg:py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <span className="text-[#C45B9F] font-medium uppercase tracking-wider text-sm">
            Nos réalisations
          </span>
          <h2 className="font-heading text-4xl lg:text-5xl text-[#3D2E35] mt-4">
            Créations Florales
          </h2>
          <p className="text-[#6B5A62] mt-4 max-w-2xl mx-auto">
            Chaque composition est une poésie visuelle, inspirée par la magie des tropiques
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {creations.slice(0, 6).map((creation, index) => (
            <div
              key={creation.id}
              className={`group card-tevaite overflow-hidden cursor-pointer transition-all duration-700 ${
                isVisible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="img-hover-zoom aspect-[4/5] relative">
                <img
                  src={creation.image}
                  alt={creation.title}
                  className="w-full h-full object-cover"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#3D2E35]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                
                {/* Content on hover */}
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <span className="text-[#E8A5C4] text-sm uppercase tracking-wider">
                    {creation.category}
                  </span>
                  <h3 className="text-white font-heading text-xl mt-1">
                    {creation.title}
                  </h3>
                  <p className="text-white/80 text-sm mt-2">
                    {creation.description}
                  </p>
                </div>
              </div>

              {/* Title below image */}
              <div className="p-5">
                <h3 className="font-heading text-lg text-[#3D2E35] group-hover:text-[#8B4B7C] transition-colors duration-300">
                  {creation.title}
                </h3>
                <p className="text-[#6B5A62] text-sm mt-1">
                  {creation.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div
          className={`text-center mt-12 transition-all duration-1000 delay-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <Link
            to="/creations"
            className="btn-tevaite inline-flex items-center px-8 py-4 rounded-full font-medium text-white"
          >
            Voir toutes nos créations
            <ArrowRight className="ml-2" size={20} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CreationsPreview;
